import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProcurementOverview from '../../components/ProcurementOverview';
import { Route } from 'react-router-dom';
import { PROCUREMENTOVERVIEW } from '../../routes';

const ProcurementOverviewRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PROCUREMENTOVERVIEW}
				render={props => <ProcurementOverview {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProcurementOverviewRoute;
